var userObject={
    //用户信息
    userid:"",
    UNAME:"申龙"
}
//是否已经开启检测登录用户是否存在
var userLoginInfo = {
    checkExists:false,
    loginPageUrl:""
};
/**
 * 获取当前登录用户信息
 */
function getCurrentUserInfo(){
    return this.userObject;
}
/**
 * 设置当前登录用户信息
 * @param {*} object 
 */
function setCurrentUserInfo(object){
    this.userObject = object;
}
/**
 * 设置当前是否需要检查用户是否登录
 * @param {*} checkExists 
 * @param {*} loginPageUrl 
 */
function setUserLoginInfo(checkExists,loginPageUrl){
    this.userLoginInfo.checkExists = checkExists;
    this.userLoginInfo.loginPageUrl = loginPageUrl;
}
/**
 * 获取当前是否需要检查用户是否登录
 * @returns 
 */
function getUserLoginInfo(){
    return this.userLoginInfo;
}
/**
 * 获取当前用户字体设置比例
 * @returns 
 */
function getUserFontSizeRatio(){
    var resultRatio = 1;
    var fontSizeRatioRule = IDM.setting.applications.userCustomConfig.fontSizeRatioRule;
    if(fontSizeRatioRule){
        try {
            resultRatio = parseFloat(IDM.express.replace("@["+fontSizeRatioRule+"]",{IDM:IDM,...this.userObject}))
        } catch (error) {
            
        }
    }
    return resultRatio
}
/**
 * 设置当前用户字体设置的比例
 * @param {*} object 
 */
function setUserFontSizeRatio(object){
    var fontSizeRatioRule = IDM.setting.applications.userCustomConfig.fontSizeRatioRule;
    fontSizeRatioRule = fontSizeRatioRule.split(".");
    var lastField = this.userObject;
    for (let index = 0; index < fontSizeRatioRule.length - 1; index++) {
        const element = fontSizeRatioRule[index];
        lastField = lastField[element];
    }
    lastField[fontSizeRatioRule[fontSizeRatioRule.length - 1]] = object;
}

export default {
    getCurrentUserInfo,
    setCurrentUserInfo,
    userObject:userObject,
    getUserFontSizeRatio,
    setUserFontSizeRatio,
    userLoginInfo,
    setUserLoginInfo,
    getUserLoginInfo
}